import "./Contests.css";
import React, { useContext } from "react";
import Context from "../../context/Context";
import arrow2 from "../../assests/arrow2.svg";
import Go from "../../assests/go.png";
import proceedButton from "../../assests/proceedButton.svg";
import "../../Pages/HomePage.css";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import { isEmpty } from "lodash";

function ContestCardView({ contestDetails, length, scrollRef }) {
  const { setPreviousLocation, searchParams } = useUserAuth();
  const { participantCount, handleUserTracking } = useContext(Context);
  const navigate = useNavigate();
  const { organizerName } = useParams();
  const campaignUniqueText = useParams().campaignUniqueText?.replace(
    /\.html$/,
    ""
  );
  var cardColour = { background: contestDetails?.buttonColor };
  var coverStyle = {
    background: ` linear-gradient(0deg, rgba(0, 0, 0,0.9) 23%, rgba(0, 0, 0, 0) 50%), url(${contestDetails?.contestPoster}) center center/cover no-repeat`,
    filter: "drop-shadow(2px 2px 2px rgba(255, 255, 255, 0.4))",
  };
  var dpBorder = { border: `1px ${contestDetails?.buttonColor} solid ` };
  const { setContentId, setContestId, preview } = useContext(Context);
  const handleButtonClick = (contestName) => {
    setPreviousLocation(window.location.pathname);
    setContestId(contestName);

    navigate({
      pathname: `/${organizerName}/${campaignUniqueText}/${contestName}.html`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  // console.log(contestDetails);
  return (
    <div
      ref={scrollRef}
      id={`C_${contestDetails?.contestId}`}
      className={`  z-[1] cursor-pointer  h-auto  rounded-[16px] ${
        length == 1 ? "w-[100%]" : "w-[75%] md:w-[75%] sm:max-w-[272px]"
      } flex text-white shrink-0 flex-grow relative`}
      style={coverStyle}
      onClick={(e) => {
        handleButtonClick(contestDetails?.contestUniqueText);
        handleUserTracking(e.currentTarget.id);
      }}
    >
      <div className="self-end w-[100%] pt-[75%] ">
        <div className="p-[16px] flex flex-col gap-[10px]">
          <p className="text-small">{contestDetails?.specs}</p>
          <p className="text-small  text_Ell w-[90%]">
            {contestDetails?.contestTagLine}
          </p>
          {/* <div className="flex items-center justify-start gap-[10px]">
            {contestDetails?.participants?.map((obj, i) => {
              return (
                <img
                  style={dpBorder}
                  src={obj?.profilePicture}
                  className="rounded-full w-[25px] h-[25px] object-cover first:ml-0 ml-[-20px]"
                  alt=""
                />
              );
            })}
          </div> */}
          <div className="flex items-center justify-between">
            <button
              className="w-fit px-[16px] py-[8px] text-small-bold text-black rounded-[50px]"
              style={cardColour}
            >
              Go to Contest
            </button>
            {!isEmpty(participantCount) && (
              <p className="text-smallest">
                Entries:{" "}
                {participantCount[contestDetails?.contestId] &&
                  participantCount[contestDetails?.contestId]
                    .participantCounter}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContestCardView;
